module.exports = __webpack_public_path__ + "static/media/GE.b7522df7.png";